"use client";

import { get } from "@/api/dashboard-auth.client";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";
import Link from "next/link";
import * as React from "react";

export function DashboardLink() {
  const t = useTranslations("SiteHeader");

  const [hasEvents, setHasEvents] = React.useState<Boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    if (window && window.localStorage.getItem("dashboard-access-token")) {
      get("/event", {
        params: {},
      }).then((fetchResponse: any) => {
        if (fetchResponse.error) {
          setHasEvents(false);
        } else {
          setHasEvents(true);
        }
      });
    } else {
      setHasEvents(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={"flex flex-row group gap-2 px-2"}>
      <Link
        href={"/home"}
        className={cn(
          " text-sm font-normal text-nowrap flex-row items-center transition-opacity opacity-0 hover:opacity-80 hidden bg-background/50 rounded-full px-3 h-6 ",
          hasEvents === true && "flex opacity-50",
        )}
      >
        {t("my-events")}
      </Link>

      <Link
        href={"/create"}
        className="flex flex-row items-center h-6 px-3 text-sm font-normal transition-opacity rounded-full opacity-50 cursor-pointer w-22 text-nowrap group hover:opacity-80 bg-background/50"
      >
        {t("create-an-event")}
      </Link>
    </div>
  );
}
